import { render, staticRenderFns } from "./TagSection.vue?vue&type=template&id=59b04095&"
import script from "./TagSection.vue?vue&type=script&lang=js&"
export * from "./TagSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports